import axios from 'axios';
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';

import { createApp } from 'vue';
import App from './App.vue';
import Vue3Lottie from 'vue3-lottie'
import router from './router';
import i18n from './i18n';
import store from '@/state/store';
import { vMaska } from "maska";
import vClickOutside from "v-click-outside";
import BootstrapVueNext from 'bootstrap-vue-next';
import './assets/tailwind.css'

import '@/assets/scss/app.scss';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap/dist/js/bootstrap.bundle';
import "leaflet/dist/leaflet.css";
import "@vueform/multiselect/themes/default.css";
import "@vueform/slider/themes/default.css";
import AOS from 'aos';
import 'aos/dist/aos.css';

const app = createApp(App);
app.use(store);
app.use(Vue3Lottie)
app.use(router);
app.use(BootstrapVueNext);
app.use(i18n);
app.directive("maska", vMaska);
app.use(vClickOutside);
app.mount('#app');

AOS.init({
  offset: 200,
  duration: 800,
  easing: 'ease-in-out',
  once: false
});
